<template >
  <div class="app-container">
    <div class="gauge-container">
      <div class="gauge-item briefing">
        <div class="gauge-head">
          <span class="subtitle">数据简报</span>
          <el-date-picker v-model="briefingTemp" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="onChangeDateRange($event, 'briefingTime')">
          </el-date-picker>
        </div>
        <div class="gauge-content">
          <el-skeleton v-if="briefingLoading" :rows="13" animated />
          <div v-else class="box-container">
            <div class="data-box pv">
              <h5 class="box-title">PV</h5>
              <p class="box-ctn">{{ briefingData.PV }}</p>
            </div>
            <div class="data-box hd">
              <h5 class="box-title">已发布活动数量</h5>
              <p class="box-ctn">{{ briefingData.activity_num }}</p>
            </div>
            <div class="data-box cp_sl">
              <h5 class="box-title">累计测评数量</h5>
              <p class="box-ctn">{{ briefingData.recommend_num }}</p>
            </div>
            <div class="data-box sp-pv">
              <h5 class="box-title">商品PV</h5>
              <p class="box-ctn">{{ briefingData.sp_PV }}</p>
            </div>
            <div class="data-box sj">
              <h5 class="box-title">商家数量</h5>
              <p class="box-ctn">{{ briefingData.store_num }}</p>
            </div>
            <div class="data-box users">
              <h5 class="box-title">用户数量</h5>
              <p class="box-ctn">{{ briefingData.user_num }}</p>
            </div>
            <div class="data-box cp_users">
              <h5 class="box-title">参与测评用户</h5>
              <p class="box-ctn">{{ briefingData.user_recommend_num }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="gauge-item">
        <div class="gauge-head">
          <span class="subtitle">相关参数趋势</span>
          <div style="margin: 5px -5px;">
            <el-select style="margin: 0 5px;" v-model="trendCategory" placeholder="趋势类型">
              <el-option label="PV" value="PV" />
              <el-option label="商品PV" value="sp_PV" />
              <el-option label="商家数量" value="store_num" />
              <el-option label="测评数量" value="recommend_num" />
              <el-option label="活动数量" value="activity_num" />
              <el-option label="用户数量" value="user_num" />
              <el-option label="测评用户" value="user_recommend_num" />
            </el-select>
            <el-date-picker style="margin: 0 5px;" v-model="trendTemp" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
              @change="onChangeDateRange($event, 'trendTime')">
            </el-date-picker>
          </div>
        </div>
        <div class="gauge-content">
          <trend-chart :category="trendCategory" :time="trendTime" />
        </div>
      </div>
      <div class="gauge-item">
        <div class="gauge-head">
          <span class="subtitle">平台分布</span>
          <el-date-picker style="margin: 0 5px;" v-model="trendTemp" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
            @change="onChangeDateRange($event, 'statisticTime')" />
        </div>
        <div class="gauge-content">
          <pie-chart :time="statisticTime" />
        </div>
      </div>
      <div class="gauge-item top5">
        <div class="gauge-head">
          <span class="subtitle">TOP5 KOC用户</span>
          <el-date-picker style="margin: 0 5px;" v-model="topFiveTemp" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
            @change="onChangeDateRange($event, 'topFiveTime')" />
        </div>
        <div class="gauge-content">
          <el-empty v-if="!topFiveLoading && topFiveData.length === 0" description="数据为空"></el-empty>
          <el-skeleton v-if="topFiveLoading" :rows="12" animated />
          <template v-else>
            <div class="top5-item" v-for="(item, index) in topFiveData" :key="index">
              <template v-if="item.user_info">
                <img class="user-picture" :src="item.user_info.head_img" alt="user">
                <div class="user-detail">
                  <p class="detail-item">微信昵称: {{ item.user_info.name }}</p>
                  <p class="detail-item">性别: {{ item.user_info.gender === 1 ? '男' : '女' }}</p>
                  <p class="detail-item">评测成功次数: {{ item.evaluation_num }}</p>
                  <p class="detail-item">活动次数: {{ item.num }}</p>
                </div>
              </template>
            </div>
          </template>
          
        </div>
      </div>
      <!-- <div class="gauge-item">
        <div class="gauge-head">
          <span class="subtitle">线上/线下测评人数</span>
          <el-date-picker v-model="testingTemp" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="onChangeDateRange($event, 'testingTime')">
          </el-date-picker>
        </div>
        <div class="gauge-content">
          <HistogramChart :time="testingTime" />
        </div>
      </div> -->
      <div class="gauge-item">
        <div class="gauge-head">
          <span class="subtitle">积分消耗</span>
          <el-date-picker v-model="pointDetailTemp" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="onChangeDateRange($event, 'pointDetailTime')">
          </el-date-picker>
        </div>
        <div class="gauge-content">
          <PointChart :time="pointDetailTime" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrendChart from "./components/TrendChart.vue"
import PieChart from './components/PieChart.vue';
import HistogramChart from "./components/HistogramChart.vue";
import PointChart from "./components/PointChart.vue";
import { briefing, topFive } from "@/api/statistic"

export default {
  data: () => ({
    value1: null,
    // 时间
    briefingTemp: null,
    briefingTime: {
      start_at: null,
      end_at: null
    },
    pointDetailTemp: null,
    pointDetailTime: {
      start_at: null,
      end_at: null
    },
    trendTemp: null,
    trendTime: {
      start_at: null,
      end_at: null
    },
    testingTemp: null,
    testingTime: {
      start_at: null,
      end_at: null
    },
    statisticTemp: null,
    statisticTime: {
      start_at: null,
      end_at: null
    },
    topFiveTemp: null,
    topFiveTime: {
      start_at: null,
      end_at: null
    },
    // 数据
    briefingData: {},
    briefingLoading: false,
    topFiveLoading: false,
    topFiveData: [],
    trendCategory: 'PV'
  }),
  components: { TrendChart, PieChart, HistogramChart, PointChart },
  methods: {
    onChangeDateRange(t, variable) {
      if (t === null) {
        this[variable].start_at = null
        this[variable].end_at = null
        return
      }
      this[variable].start_at = t[0]
      this[variable].end_at = t[1]
    },
    initBriefing() {
      this.briefingLoading = true

      briefing(this.briefingTime).then(({ data }) => {
        this.briefingData = data
      }).finally(() => {
        this.briefingLoading = false
      })
    },
    initTopFive() {
      this.topFiveLoading = true

      topFive(this.topFiveTime).then(({ data }) => {
        this.topFiveData = data
      }).finally(() => {
        this.topFiveLoading = false
      })
    },
  },
  watch: {
    briefingTime: {
      handler: function () {
        this.initBriefing()
      },
      deep: true
    },
    topFiveTime: {
      handler: function () {
        this.initTopFive()
      },
      deep: true
    }
  },
  mounted() {
    this.initBriefing()
    this.initTopFive()
  }
}
</script>

<style lang="scss" scoped>
.gauge-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 10px;
  row-gap: 10px;

  .gauge-item {
    border-radius: 3px;
    overflow: hidden;
    border: 1px solid #ecf0f1;

    .gauge-head {
      min-height: 60px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      background-color: #ecf0f1;

      .subtitle {
        font-size: 1rem;
        line-height: 2rem;
        color: #34495e;
      }
    }

    #trend-chart,
    #pie-chart {
      // width: 100%;
      min-height: 512px;
    }
  }
}

@media (max-width: 999px) {
  .gauge-container {
    grid-template-columns: 1fr;
  }
}

.briefing {
  .gauge-content {
    padding: 10px;

    .box-container {
      display: grid;
      grid-gap: 10px;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      background-color: white;
    }
  }

  .data-box {
    // width: 200px;
    height: 100px;
    border-radius: var(--border-radius);
    // background: #f1f1f3;
    box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 3%);
    border-radius: 0.75rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
    margin: 10px;

    .box-title {
      margin: 0;
      margin-top: 19px;
    }

    .box-ctn {
      font-size: 22px;
      font-family: "PingFangSC-Semibold, PingFang SC";
      font-weight: 600;
      color: #333;
      // text-align: center;
    }
  }

  .pv {
    background: url('../../icons/background/PV.svg');
  }

  .hd {
    background: url("../../icons/background/hd.svg");
  }

  .cp_sl {
    background: url("../../icons/background/cp_sl.svg");
  }

  .sp-pv {
    background: url("../../icons/background/sp_PV.svg");
  }

  .sj {
    background: url("../../icons/background/sj.svg");
  }

  .users {
    background: url("../../icons/background/users.svg");
  }

  .cp_users {
    background: url("../../icons/background/cp_users.svg");
  }
}

.top5 .gauge-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(232px, 1fr));
  row-gap: 30px;
  padding: 30px;

  .top5-item {
    display: flex;
    justify-content: center;
    align-items: center;

    .user-picture {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .user-detail {
      text-align: left;
      margin-left: 15px;
      color: #34495e;

      .detail-item {
        font-size: .8rem;
        line-height: 1.2rem;
        margin: 0;
      }
    }
  }
}
</style>